import React from "react";

const SimColumns = ({ children, col, sm, md, lg, xl, xxl, offset, order, className = "" }) => {
  const buildColumnClass = (size, breakpoint) => {
    return size ? `col-${breakpoint}-${size}` : "";
  };

  const colClasses = [
    col ? `col-${col}` : "",
    buildColumnClass(sm, "sm"),
    buildColumnClass(md, "md"),
    buildColumnClass(lg, "lg"),
    buildColumnClass(xl, "xl"),
    buildColumnClass(xxl, "xxl"),
    offset ? `offset-${offset}` : "",
    order ? `order-${order}` : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <>
      <div className={`${colClasses} ${className}`}>{children}</div>
    </>
  );
};

export default SimColumns;
